module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/118-malasya-5c3b670de3dd4f9db0c998f61e304614.svg";